import { Bill } from '@features/bills/types/bill'
import { Contact } from '@features/contacts/types/contact'

export const getContactFromBill = (bill: Bill, contacts?: Contact[]): Contact | undefined => {
  const contactId = bill.contactId

  if (!contactId) {
    return undefined
  }

  return contacts?.find((contact) => contactId === contact.id)
}
